/* One sticky CTA for Wondernara video calls. Hide it while customers can see the entry selector. */
(() => {
  'use strict';
  const init=()=>{
    const sticky=document.querySelector('sticky-add-to-cart.sticky-add-to-cart--wn-vc-clean');
    if(!sticky||sticky.dataset.wnStickyBound==='true')return;
    sticky.dataset.wnStickyBound='true';
    const findPicker=()=>document.querySelector('product-variants[data-wn-vc-apply]')
      ||document.querySelector('.wn-ateez-variant-ui product-variants')
      ||document.querySelector('product-variants .product-variants--radio')
      ||document.querySelector('product-variants');
    let queued=false;
    const refresh=()=>{
      queued=false;
      const picker=findPicker();
      if(!picker){sticky.classList.remove('wn-vc-sticky--picker-visible');return}
      const box=picker.getBoundingClientRect();
      const isVisible=box.top<window.innerHeight-90 && box.bottom>110;
      sticky.classList.toggle('wn-vc-sticky--picker-visible',isVisible);
    };
    const schedule=()=>{if(queued)return;queued=true;window.requestAnimationFrame(refresh)};
    window.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('resize',schedule,{passive:true});
    document.addEventListener('shopify:section:load',schedule);
    refresh();
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();
